export enum MapOverlay {
  DriveTime = 'drive-time',
  RadiusRings = 'radius-rings',
  TrueTradeArea = 'true-trade-area',
}
